import type { Type } from '@angular/core';

/**
 * Port: the one help-assistant component the admin layout renders, beside the manual help panel.
 *
 * A package binds it through `frontend.bindings` of its manifest
 * (`{ provide: HelpAssistantEntry, useClass: <adapter> }` in `aurora-port.providers.ts`). The
 * scaffold binds nothing, so the layout renders no assistant there.
 *
 * What does NOT belong here: any other layout element. Each one needs its own token. The last
 * binding wins (Angular resolves a token to its last provider), so an application has one assistant.
 */
export abstract class HelpAssistantEntry {
  /**
   * Loads the component on demand. The binding sits in the eager app providers, so a static
   * reference would pull the whole assistant into the initial bundle.
   */
  abstract loadComponent(): Promise<Type<unknown>>;
}
